var reduxBundler = require('redux-bundler');

var OFFLINE = 'OFFLINE';
var ONLINE = 'ONLINE';
var onlineBundle = {
  name: 'online',
  selectIsOnline: function (state) { return state.online; },
  getReducer: function () {
    var initialState = reduxBundler.IS_BROWSER ? navigator.onLine : true;
    return function (state, ref) {
      if ( state === void 0 ) state = initialState;
      var type = ref.type;

      if (type === OFFLINE) { return false; }
      if (type === ONLINE) { return true; }
      return state;
    };
  },
  init: function (store) {
    var removeOnlineListener = reduxBundler.addGlobalListener('online', function () { return store.dispatch({
      type: ONLINE
    }); });
    var removeOfflineListener = reduxBundler.addGlobalListener('offline', function () { return store.dispatch({
      type: OFFLINE
    }); });
    return function () {
      removeOnlineListener();
      removeOfflineListener();
    };
  }
};

module.exports = onlineBundle;
